// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AboutSpecialties Component Styles */
.about-specialties {
  padding: 80px 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  clear: both;
  overflow: hidden;
}

.about-specialties__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.about-specialties__header {
  text-align: center;
  margin-bottom: 4rem;
}

.about-specialties__title {
  font-size: 2.5rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: #4A90E2;
  position: relative;
  padding-bottom: 1rem;
}

.about-specialties__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #4A90E2, #87ceeb);
  border-radius: 2px;
}

.about-specialties__intro {
  font-size: 1.15rem;
  line-height: 1.7;
  color: #555;
  max-width: 900px;
  margin: 0 auto;
  text-align: justify;
}

.about-specialties__highlights {
  margin-top: 3rem;
}

.about-specialties__subtitle {
  font-size: 1.5rem;
  font-weight: 500;
  color: #4A90E2;
  margin-bottom: 2rem;
  text-align: center;
}

.about-restaurant__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
}

.about-specialties__item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(74, 144, 226, 0.08);
  transition: all 0.3s ease;
  border: 1px solid rgba(74, 144, 226, 0.1);
}

.about-specialties__item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(74, 144, 226, 0.15);
  border-color: rgba(74, 144, 226, 0.2);
}

.about-specialties__item-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.about-specialties__item-content {
  flex: 1;
}

.about-specialties__item-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  color: #4A90E2;
  line-height: 1.3;
}

.about-specialties__item-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  text-align: justify;
}

/* Animation for items - removed problematic opacity: 0 */

/* Responsive Design */
@media (max-width: 768px) {
  .about-specialties {
    padding: 60px 0;
  }
  
  .about-specialties__container {
    padding: 0 1.5rem;
  }
  
  .about-specialties__title {
    font-size: 2rem;
  }
  
  .about-specialties__intro {
    font-size: 1rem;
    text-align: left;
  }
  
  .about-specialties__grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .about-specialties__item {
    padding: 1.5rem;
    gap: 1rem;
  }
  
  .about-specialties__item-title {
    font-size: 1.1rem;
  }
  
  .about-specialties__item-description {
    font-size: 0.95rem;
    text-align: left;
  }
}

@media (max-width: 600px) {
  .about-specialties__grid {
    grid-template-columns: 1fr;
  }
  
  .about-specialties__item {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .about-specialties__item-icon {
    margin: 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutSpecialties.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,eAAe;EACf,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,yDAAyD;;AAEzD,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* AboutSpecialties Component Styles */\n.about-specialties {\n  padding: 80px 0;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  clear: both;\n  overflow: hidden;\n}\n\n.about-specialties__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.about-specialties__header {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.about-specialties__title {\n  font-size: 2.5rem;\n  font-weight: 400;\n  margin-bottom: 2rem;\n  color: #4A90E2;\n  position: relative;\n  padding-bottom: 1rem;\n}\n\n.about-specialties__title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: linear-gradient(90deg, #4A90E2, #87ceeb);\n  border-radius: 2px;\n}\n\n.about-specialties__intro {\n  font-size: 1.15rem;\n  line-height: 1.7;\n  color: #555;\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: justify;\n}\n\n.about-specialties__highlights {\n  margin-top: 3rem;\n}\n\n.about-specialties__subtitle {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #4A90E2;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.about-restaurant__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.about-specialties__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 12px;\n  box-shadow: 0 5px 20px rgba(74, 144, 226, 0.08);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(74, 144, 226, 0.1);\n}\n\n.about-specialties__item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(74, 144, 226, 0.15);\n  border-color: rgba(74, 144, 226, 0.2);\n}\n\n.about-specialties__item-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.2rem;\n  font-weight: bold;\n  flex-shrink: 0;\n  margin-top: 0.2rem;\n}\n\n.about-specialties__item-content {\n  flex: 1;\n}\n\n.about-specialties__item-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n  color: #4A90E2;\n  line-height: 1.3;\n}\n\n.about-specialties__item-description {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #666;\n  text-align: justify;\n}\n\n/* Animation for items - removed problematic opacity: 0 */\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-specialties {\n    padding: 60px 0;\n  }\n  \n  .about-specialties__container {\n    padding: 0 1.5rem;\n  }\n  \n  .about-specialties__title {\n    font-size: 2rem;\n  }\n  \n  .about-specialties__intro {\n    font-size: 1rem;\n    text-align: left;\n  }\n  \n  .about-specialties__grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .about-specialties__item {\n    padding: 1.5rem;\n    gap: 1rem;\n  }\n  \n  .about-specialties__item-title {\n    font-size: 1.1rem;\n  }\n  \n  .about-specialties__item-description {\n    font-size: 0.95rem;\n    text-align: left;\n  }\n}\n\n@media (max-width: 600px) {\n  .about-specialties__grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .about-specialties__item {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .about-specialties__item-icon {\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
